// SPEEDOGO - Lazy load de vídeos pesados (autoplay) fora da primeira tela.
// O <video>/video_tag real fica dentro de um <template> (não baixa nada) e só
// é inserido no DOM (e passa a baixar/rodar) quando o slot chega perto da
// tela visível. Isso evita baixar vários vídeos MP4 no carregamento inicial
// da página, que é a maior causa de lentidão em seções mais abaixo.
(function () {
  function loadSlot(slot) {
    if (!slot || slot.getAttribute('data-loaded') === '1') return;
    var tpl = slot.previousElementSibling;
    if (!tpl || tpl.tagName !== 'TEMPLATE') {
      tpl = slot.parentElement ? slot.parentElement.querySelector('template[data-lazy-video]') : null;
    }
    if (!tpl) return;
    slot.setAttribute('data-loaded', '1');
    slot.appendChild(tpl.content.cloneNode(true));
  }

  function init() {
    var slots = document.querySelectorAll('[data-lazy-video-slot]');
    if (!slots.length) return;

    if (!('IntersectionObserver' in window)) {
      slots.forEach(loadSlot);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          loadSlot(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '300px 0px' });

    slots.forEach(function (slot) { observer.observe(slot); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
